var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTentacleHeader(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 389,
    height: 465,
    viewBox: "0 0 389 465",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_664_7450",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 389,
    height: 465
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 389,
    height: 465,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_664_7450)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M154.357 -133.004C151.828 -137.83 142.535 -146.786 127.473 -151.931L-24.8881 -72.0708C-31.566 -53.9874 -27.2315 -41.6964 -27.2315 -41.6964C-27.2315 -41.6964 -3.11958 8.57667 59.696 29.8091C104.676 45.0101 204.69 20.9772 228.987 101.772C252.127 178.706 167.071 186.638 139.847 226.555C100.392 284.409 98.3289 367.231 184.534 402.435C230.36 421.156 283.843 379.175 312.586 389.988C343.003 401.436 344.289 433.347 338.907 453.615C337.51 458.876 343.651 462.878 347.926 459.508C369.267 442.674 396.855 406.934 355.323 350.402C322.262 305.394 244.362 362.766 214.385 317.12C192.36 283.584 278.925 274.568 343.793 192.793C409.613 109.834 371.716 2.13049 278.619 -43.7219C173.587 -95.451 159.545 -123.107 154.357 -133.004Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 8.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5182 -96.919L-25.5447 -71.7267C-32.2748 -52.8192 -26.4514 -40.1891 -26.4514 -40.1891C-26.4514 -40.1891 -2.33956 10.084 60.476 31.3165C105.456 46.5175 205.47 22.4845 229.767 103.279C252.907 180.213 167.851 188.146 140.627 228.062C101.172 285.916 99.1089 368.738 185.314 403.942C231.14 422.663 284.623 380.682 313.366 391.495C343.783 402.943 342.549 431.375 337.18 451.647C336.062 455.863 338.953 461.014 342.678 460.463C340.082 449.218 365.03 399.744 334.166 380.401C285.65 349.989 202.506 413.095 158.526 334.73C130.274 284.388 171.127 241.574 216.008 217.122C260.888 192.67 301.101 114.268 260.509 56.991C189.626 -43.0136 77.9657 15.735 22.5103 -96.9148L22.5182 -96.919Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 8.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.2469 -77.6484L-24.9355 -72.046C-32.3826 -52.8131 -27.2393 -41.6923 -27.2393 -41.6923C-27.2393 -41.6923 -3.12747 8.58082 59.6881 29.8133C74.3826 34.7781 94.9423 35.5593 116.816 37.1744C39.4464 19.1332 -2.49702 -33.2199 -14.2428 -77.6405L-14.2469 -77.6484Z",
    fill: "#D16984",
    stroke: "#7A1D24",
    strokeWidth: 8.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.857 405.172C151.425 383.543 137.802 358.34 130.143 335.589C118.417 300.789 132.729 258.846 157.722 235.51C182.715 212.174 229.892 195.816 240.872 149.115C247.645 120.302 223.836 88.366 223.836 88.366C225.8 92.4797 227.528 96.9296 228.983 101.764C252.122 178.698 167.067 186.63 139.843 226.547C100.388 284.401 98.3248 367.223 184.53 402.427C187.276 403.549 190.058 404.451 192.853 405.165L192.857 405.172Z",
    fill: "#D16984",
    stroke: "#7A1D24",
    strokeWidth: 8.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M154.357 -133.004C151.828 -137.83 142.535 -146.786 127.473 -151.931L-24.8881 -72.0708C-31.566 -53.9874 -27.2315 -41.6964 -27.2315 -41.6964C-27.2315 -41.6964 -3.11958 8.57667 59.696 29.8091C104.676 45.0101 204.69 20.9772 228.987 101.772C252.127 178.706 167.071 186.638 139.847 226.555C100.392 284.409 98.3289 367.231 184.534 402.435C230.36 421.156 283.843 379.175 312.586 389.988C343.003 401.436 344.289 433.347 338.907 453.615C337.51 458.876 343.651 462.878 347.926 459.508C369.267 442.674 396.855 406.934 355.323 350.402C322.262 305.394 244.362 362.766 214.385 317.12C192.36 283.584 278.925 274.568 343.793 192.793C409.613 109.834 371.716 2.13049 278.619 -43.7219C173.587 -95.451 159.545 -123.107 154.357 -133.004Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5182 -96.919L-25.5447 -71.7267C-32.2748 -52.8192 -26.4514 -40.1891 -26.4514 -40.1891C-26.4514 -40.1891 -2.33956 10.084 60.476 31.3165C105.456 46.5175 205.47 22.4845 229.767 103.279C252.907 180.213 167.851 188.146 140.627 228.062C101.172 285.916 99.1089 368.738 185.314 403.942C231.14 422.663 284.623 380.682 313.366 391.495C343.783 402.943 342.549 431.375 337.18 451.647C336.062 455.863 338.953 461.014 342.678 460.463C340.082 449.218 365.03 399.744 334.166 380.401C285.65 349.989 202.506 413.095 158.526 334.73C130.274 284.388 171.127 241.574 216.008 217.122C260.888 192.67 301.101 114.268 260.509 56.991C189.626 -43.0136 77.9657 15.735 22.5103 -96.9148L22.5182 -96.919Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-14.2469 -77.6484L-24.9355 -72.046C-32.3826 -52.8131 -27.2393 -41.6923 -27.2393 -41.6923C-27.2393 -41.6923 -3.12747 8.58082 59.6881 29.8133C74.3826 34.7781 94.9423 35.5593 116.816 37.1744C39.4464 19.1332 -2.49702 -33.2199 -14.2428 -77.6405L-14.2469 -77.6484Z",
    fill: "#D16984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.857 405.172C151.425 383.543 137.802 358.34 130.143 335.589C118.417 300.789 132.729 258.846 157.722 235.51C182.715 212.174 229.892 195.816 240.872 149.115C247.645 120.302 223.836 88.366 223.836 88.366C225.8 92.4797 227.528 96.9296 228.983 101.764C252.122 178.698 167.067 186.63 139.843 226.547C100.388 284.401 98.3248 367.223 184.53 402.427C187.276 403.549 190.058 404.451 192.853 405.165L192.857 405.172Z",
    fill: "#D16984"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.137 -56.4486C151.112 -44.5783 161.272 -25.5715 180.831 -13.9959C200.39 -2.42019 221.941 -2.65907 228.966 -14.5294C235.992 -26.3998 225.831 -45.4065 206.272 -56.9822C186.713 -68.5579 165.162 -68.319 158.137 -56.4486Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.195 -12.088C222.652 -2.12885 228.218 18.692 244.628 34.4167C261.038 50.1413 282.077 54.8152 291.62 44.8561C301.164 34.8969 295.597 14.0761 279.188 -1.64861C262.778 -17.3733 241.739 -22.0471 232.195 -12.088Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.022 26.7367C244.092 18.1855 241.067 6.8523 246.253 1.43108C251.443 -3.98223 262.891 -1.44045 271.821 7.11078C280.75 15.662 283.776 26.9952 278.59 32.4164C273.4 37.8297 261.952 35.2879 253.022 26.7367Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.057 -34.5883C270.869 -25.1091 276.892 -6.48967 292.509 6.99936C308.126 20.4884 327.423 23.739 335.611 14.2598C343.798 4.78064 337.776 -13.8388 322.159 -27.3278C306.542 -40.8168 287.245 -44.0674 279.057 -34.5883Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.754 -0.359927C291.259 -7.69686 287.977 -17.8265 292.433 -22.986C296.889 -28.1456 307.387 -26.3767 315.886 -19.0318C324.381 -11.6949 327.663 -1.56528 323.207 3.59424C318.751 8.75377 308.253 6.98492 299.754 -0.359927Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.239 97.1026C291.857 115.864 308.993 126.41 321.514 120.659C334.035 114.907 337.199 95.0361 328.581 76.2749C319.963 57.5137 302.827 46.9672 290.306 52.7186C277.785 58.47 274.621 78.3414 283.239 97.1026Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.905 93.1701C289.155 82.9927 290.781 72.1258 297.551 68.8998C304.322 65.6737 313.659 71.3084 318.409 81.4859C323.159 91.6634 321.533 102.53 314.762 105.756C307.992 108.982 298.654 103.348 293.905 93.1701Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.177 31.856C330.119 38.3704 328.257 58.2954 338.017 76.3598C347.776 94.4242 365.463 103.787 377.52 97.2731C389.578 90.7587 391.44 70.8336 381.68 52.7692C371.921 34.7048 354.234 25.3416 342.177 31.856Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.237 71.5497C342.938 61.7104 343.977 50.8787 350.555 47.3607C357.128 43.8348 366.751 48.9566 372.041 58.8001C377.34 68.6394 376.301 79.471 369.723 82.989C363.15 86.515 353.527 81.3932 348.237 71.5497Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.577 158.971C269.428 179.237 275.404 198.992 288.924 203.094C302.444 207.196 318.39 194.093 324.539 173.827C330.688 153.56 324.712 133.806 311.192 129.703C297.672 125.601 281.726 138.705 275.577 158.971Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.442 163.19C289.719 152.143 298.363 144.91 305.751 147.038C313.14 149.166 316.476 159.842 313.2 170.888C309.923 181.935 301.279 189.168 293.891 187.04C286.503 184.912 283.166 174.236 286.442 163.19Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.648 150.975C329.03 170.662 335.119 188.928 347.246 191.772C359.374 194.616 372.948 180.962 377.565 161.275C382.182 141.587 376.094 123.322 363.966 120.478C351.839 117.634 338.265 131.288 333.648 150.975Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.475 153.959C340.963 164.67 344.277 174.607 350.876 176.155C357.475 177.703 364.861 170.275 367.373 159.564C369.885 148.853 366.571 138.916 359.972 137.368C353.373 135.821 345.987 143.249 343.475 153.959Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.52 203.732C225.036 215.115 221.493 233.095 230.608 243.892C239.722 254.688 258.041 254.212 271.525 242.829C285.009 231.445 288.552 213.465 279.437 202.669C270.323 191.873 252.004 192.349 238.52 203.732Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.347 213.18C252.594 206.881 262.594 206.45 267.687 212.202C272.775 217.966 271.033 227.744 263.786 234.044C256.539 240.343 246.538 240.774 241.446 235.022C236.357 229.258 238.1 219.48 245.347 213.18Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.611 207.346C287.777 219.941 283.664 236.562 291.425 244.47C299.186 252.378 315.881 248.579 328.715 235.984C341.549 223.389 345.662 206.768 337.901 198.86C330.14 190.952 313.445 194.751 300.611 207.346Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.594 214.258C313.587 207.416 322.665 205.36 326.875 209.678C331.085 213.997 328.829 223.046 321.836 229.888C314.843 236.73 305.765 238.786 301.555 234.467C297.345 230.149 299.601 221.1 306.594 214.258Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.458 245.603C166.827 255.86 162.436 273.024 170.649 283.939C178.863 294.854 196.571 295.387 210.203 285.13C223.834 274.873 228.225 257.709 220.012 246.794C211.798 235.879 194.09 235.345 180.458 245.603Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.777 254.943C179.362 260.522 176.973 269.858 181.44 275.795C185.907 281.731 195.539 282.02 202.954 276.441C210.369 270.861 212.758 261.526 208.291 255.589C203.824 249.653 194.191 249.363 186.777 254.943Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.813 260.487C256.824 251.721 272.147 250.033 276.034 256.719C279.922 263.405 270.896 275.932 255.885 284.697C240.874 293.463 225.552 295.151 221.664 288.465C217.776 281.779 226.802 269.252 241.813 260.487Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.517 266.28C252.688 261.513 261.021 260.594 263.129 264.23C265.248 267.869 260.336 274.68 252.165 279.447C243.993 284.214 235.66 285.132 233.553 281.497C231.434 277.858 236.346 271.047 244.517 266.28Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.046 323.458C154.493 336.515 164.14 346.161 174.594 345.003C185.047 343.845 192.349 332.321 190.903 319.264C189.456 306.206 179.809 296.56 169.355 297.718C158.902 298.876 151.6 310.4 153.046 323.458Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.721 323.162C160.83 316.075 164.712 309.704 170.387 308.948C176.062 308.192 181.382 313.32 182.269 320.419C183.16 327.506 179.278 333.877 173.603 334.633C167.928 335.389 162.608 330.261 161.721 323.162Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.729 315.371C194.171 303.087 199.426 292.255 207.46 291.17C215.486 290.089 223.263 299.174 224.813 311.462C226.371 323.747 221.116 334.579 213.082 335.664C205.056 336.744 197.279 327.66 195.729 315.371Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.384 314.888C201.541 308.2 204.393 302.308 208.765 301.721C213.136 301.134 217.362 306.079 218.201 312.76C219.045 319.448 216.193 325.34 211.821 325.927C207.449 326.514 203.223 321.569 202.384 314.888Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.736 347.129C188.662 352.731 191.449 363.522 199.962 371.232C208.474 378.941 219.487 380.65 224.561 375.049C229.635 369.447 226.847 358.656 218.335 350.946C209.823 343.236 198.809 341.527 193.736 347.129Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.491 366.953C199.837 362.787 198.266 356.904 200.98 353.827C203.697 350.739 209.676 351.619 214.33 355.785C218.985 359.951 220.556 365.834 217.842 368.911C215.124 371.999 209.146 371.119 204.491 366.953Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.315 352.491C226.475 350.287 220.55 343.388 222.067 337.086C223.585 330.784 231.98 327.463 240.824 329.675C249.664 331.879 255.59 338.778 254.072 345.08C252.554 351.382 244.16 354.703 235.315 352.491Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.86 347.375C232.054 346.172 228.826 342.418 229.651 338.991C230.476 335.563 235.045 333.753 239.85 334.956C244.656 336.158 247.884 339.912 247.059 343.34C246.233 346.768 241.665 348.578 236.86 347.375Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.137 381.926C241.21 380.342 233.96 373.745 234.95 367.205C235.939 360.666 244.792 356.64 254.731 358.228C264.658 359.812 271.908 366.41 270.919 372.949C269.921 379.493 261.076 383.514 251.137 381.926Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.278 376.598C246.876 375.739 242.927 372.151 243.47 368.588C244.014 365.026 248.83 362.844 254.233 363.704C259.635 364.563 263.583 368.151 263.04 371.714C262.497 375.276 257.68 377.458 252.278 376.598Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.044 357.666C264.704 358.013 257.675 352.954 257.349 346.368C257.023 339.781 263.52 334.167 271.868 333.816C280.208 333.468 287.237 338.528 287.563 345.114C287.889 351.7 281.391 357.314 273.044 357.666Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.052 352.236C268.512 352.427 264.688 349.671 264.516 346.091C264.343 342.51 267.873 339.45 272.416 339.267C276.955 339.076 280.78 341.832 280.952 345.412C281.124 348.993 277.595 352.053 273.052 352.236Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.927 376.159C287.846 376.825 280.1 372.514 279.614 366.546C279.129 360.578 286.102 355.199 295.175 354.538C304.256 353.872 312.001 358.183 312.487 364.151C312.973 370.119 306 375.498 296.927 376.159Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.825 371.231C291.889 371.589 287.669 369.253 287.407 366.001C287.145 362.75 290.937 359.825 295.872 359.467C300.808 359.108 305.028 361.445 305.29 364.696C305.552 367.948 301.76 370.873 296.825 371.231Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.992 353.315C295.412 352.547 288.039 346.599 288.512 340.018C288.989 333.444 297.13 328.733 306.706 329.493C316.286 330.261 323.659 336.209 323.186 342.79C322.708 349.364 314.568 354.075 304.992 353.315Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.727 340.628C296.416 344.201 300.383 347.465 305.587 347.919C310.792 348.372 315.263 345.843 315.575 342.27C315.886 338.697 311.919 335.433 306.714 334.98C301.51 334.526 297.038 337.055 296.727 340.628Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.323 379.862C315.847 377.931 309.961 371.839 311.197 366.249C312.42 360.656 320.287 357.693 328.77 359.62C337.245 361.552 343.131 367.644 341.896 373.233C340.672 378.826 332.806 381.79 324.323 379.862Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.618 375.331C321.004 374.28 317.804 370.965 318.477 367.92C319.142 364.879 323.422 363.271 328.033 364.313C332.648 365.363 335.847 368.678 335.175 371.724C334.51 374.765 330.233 376.381 325.618 375.331Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.07 361.24C329.535 357.867 324.458 350.373 326.722 344.497C328.987 338.62 337.746 336.59 346.281 339.963C354.816 343.336 359.894 350.83 357.629 356.707C355.365 362.583 346.605 364.613 338.07 361.24Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.218 356.524C335.576 354.691 332.813 350.613 334.042 347.417C335.279 344.217 340.037 343.115 344.683 344.956C349.325 346.789 352.088 350.867 350.858 354.063C349.621 357.263 344.864 358.365 340.218 356.524Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.718 395.373C341.131 388.399 342.746 381.34 347.32 379.598C351.893 377.856 357.7 382.104 360.287 389.079C362.873 396.053 361.258 403.112 356.685 404.854C352.111 406.596 346.305 402.348 343.718 395.373Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.567 394.173C346.164 390.38 347.033 386.536 349.524 385.593C352.015 384.65 355.172 386.959 356.583 390.748C357.986 394.541 357.116 398.385 354.625 399.328C352.134 400.27 348.978 397.962 347.567 394.173Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.922 383.592C355.877 377.684 355.862 370.613 359.895 367.803C363.929 364.992 370.478 367.5 374.534 373.412C378.579 379.32 378.594 386.391 374.561 389.201C370.527 392.011 363.979 389.504 359.922 383.592Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.369 381.473C361.17 378.258 361.161 374.411 363.353 372.879C365.545 371.346 369.115 372.712 371.314 375.927C373.513 379.141 373.523 382.988 371.331 384.521C369.139 386.053 365.568 384.687 363.369 381.473Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.715 419.087C349.781 412.386 354.234 407.49 358.65 408.161C363.066 408.831 365.781 414.801 364.707 421.506C363.64 428.206 359.187 433.102 354.771 432.431C350.356 431.761 347.64 425.792 348.715 419.087Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.305 419.857C352.887 416.214 355.305 413.555 357.709 413.908C360.109 414.274 361.59 417.522 361.008 421.165C360.427 424.808 358.009 427.467 355.605 427.114C353.204 426.748 351.724 423.5 352.305 419.857Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.216 409.358C368.411 402.54 373.99 398.194 378.685 399.666C383.375 401.131 385.406 407.852 383.211 414.671C381.016 421.489 375.438 425.835 370.743 424.363C366.052 422.898 364.022 416.177 366.216 409.358Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.999 410.784C371.191 407.074 374.23 404.714 376.783 405.504C379.339 406.302 380.44 409.961 379.248 413.672C378.057 417.382 375.017 419.742 372.465 418.952C369.909 418.154 368.808 414.495 369.999 410.784Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.029 435.141C360.509 429.313 365.744 426.005 368.722 427.742C371.704 429.486 371.294 435.631 367.822 441.455C364.341 447.283 359.106 450.592 356.124 448.847C353.142 447.102 353.552 440.957 357.025 435.133L357.029 435.141Z",
    fill: "#F0869D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.365 436.771C361.254 433.602 364.101 431.797 365.729 432.749C367.345 433.697 367.13 437.037 365.233 440.21C363.343 443.379 360.497 445.183 358.869 444.232C357.253 443.284 357.468 439.943 359.365 436.771Z",
    fill: "#F7C6CF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.137 -56.4486C151.112 -44.5783 161.272 -25.5715 180.831 -13.9959C200.39 -2.42019 221.941 -2.65907 228.966 -14.5294C235.992 -26.3998 225.831 -45.4065 206.272 -56.9822C186.713 -68.5579 165.162 -68.319 158.137 -56.4486Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.195 -12.088C222.652 -2.12885 228.218 18.692 244.628 34.4167C261.038 50.1413 282.077 54.8152 291.62 44.8561C301.164 34.8969 295.597 14.0761 279.188 -1.64861C262.778 -17.3733 241.739 -22.0471 232.195 -12.088Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.022 26.7367C244.092 18.1855 241.067 6.8523 246.253 1.43108C251.443 -3.98223 262.891 -1.44045 271.821 7.11078C280.75 15.662 283.776 26.9952 278.59 32.4164C273.4 37.8297 261.952 35.2879 253.022 26.7367Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.057 -34.5883C270.869 -25.1091 276.892 -6.48967 292.509 6.99936C308.126 20.4884 327.423 23.739 335.611 14.2598C343.798 4.78064 337.776 -13.8388 322.159 -27.3278C306.542 -40.8168 287.245 -44.0674 279.057 -34.5883Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.754 -0.359927C291.259 -7.69686 287.977 -17.8265 292.433 -22.986C296.889 -28.1456 307.387 -26.3767 315.886 -19.0318C324.381 -11.6949 327.663 -1.56528 323.207 3.59424C318.751 8.75377 308.253 6.98492 299.754 -0.359927Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M283.239 97.1026C291.857 115.864 308.993 126.41 321.514 120.659C334.035 114.907 337.199 95.0361 328.581 76.2749C319.963 57.5137 302.827 46.9672 290.306 52.7186C277.785 58.47 274.621 78.3414 283.239 97.1026Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.905 93.1701C289.155 82.9927 290.781 72.1258 297.551 68.8998C304.322 65.6737 313.659 71.3084 318.409 81.4859C323.159 91.6634 321.533 102.53 314.762 105.756C307.992 108.982 298.654 103.348 293.905 93.1701Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.177 31.856C330.119 38.3704 328.257 58.2954 338.017 76.3598C347.776 94.4242 365.463 103.787 377.52 97.2731C389.578 90.7587 391.44 70.8336 381.68 52.7692C371.921 34.7048 354.234 25.3416 342.177 31.856Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.237 71.5497C342.938 61.7104 343.977 50.8787 350.555 47.3607C357.128 43.8348 366.751 48.9566 372.041 58.8001C377.34 68.6394 376.301 79.471 369.723 82.989C363.15 86.515 353.527 81.3932 348.237 71.5497Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.577 158.971C269.428 179.237 275.404 198.992 288.924 203.094C302.444 207.196 318.39 194.093 324.539 173.827C330.688 153.56 324.712 133.806 311.192 129.703C297.672 125.601 281.726 138.705 275.577 158.971Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.442 163.19C289.719 152.143 298.363 144.91 305.751 147.038C313.14 149.166 316.476 159.842 313.2 170.888C309.923 181.935 301.279 189.168 293.891 187.04C286.503 184.912 283.166 174.236 286.442 163.19Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.648 150.975C329.03 170.662 335.119 188.928 347.246 191.772C359.374 194.616 372.948 180.962 377.565 161.275C382.182 141.587 376.094 123.322 363.966 120.478C351.839 117.634 338.265 131.288 333.648 150.975Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.475 153.959C340.963 164.67 344.277 174.607 350.876 176.155C357.475 177.703 364.861 170.275 367.373 159.564C369.885 148.853 366.571 138.916 359.972 137.368C353.373 135.821 345.987 143.249 343.475 153.959Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.52 203.732C225.036 215.115 221.493 233.095 230.608 243.892C239.722 254.688 258.041 254.212 271.525 242.829C285.009 231.445 288.552 213.465 279.437 202.669C270.323 191.873 252.004 192.349 238.52 203.732Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.347 213.18C252.594 206.881 262.594 206.45 267.687 212.202C272.775 217.966 271.033 227.744 263.786 234.044C256.539 240.343 246.538 240.774 241.446 235.022C236.357 229.258 238.1 219.48 245.347 213.18Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.611 207.346C287.777 219.941 283.664 236.562 291.425 244.47C299.186 252.378 315.881 248.579 328.715 235.984C341.549 223.389 345.662 206.768 337.901 198.86C330.14 190.952 313.445 194.751 300.611 207.346Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.594 214.258C313.587 207.416 322.665 205.36 326.875 209.678C331.085 213.997 328.829 223.046 321.836 229.888C314.843 236.73 305.765 238.786 301.555 234.467C297.345 230.149 299.601 221.1 306.594 214.258Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.458 245.603C166.827 255.86 162.436 273.024 170.649 283.939C178.863 294.854 196.571 295.387 210.203 285.13C223.834 274.873 228.225 257.709 220.012 246.794C211.798 235.879 194.09 235.345 180.458 245.603Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.777 254.943C179.362 260.522 176.973 269.858 181.44 275.795C185.907 281.731 195.539 282.02 202.954 276.441C210.369 270.861 212.758 261.526 208.291 255.589C203.824 249.653 194.191 249.363 186.777 254.943Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.813 260.487C256.824 251.721 272.147 250.033 276.034 256.719C279.922 263.405 270.896 275.932 255.885 284.697C240.874 293.463 225.552 295.151 221.664 288.465C217.776 281.779 226.802 269.252 241.813 260.487Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.517 266.28C252.688 261.513 261.021 260.594 263.129 264.23C265.248 267.869 260.336 274.68 252.165 279.447C243.993 284.214 235.66 285.132 233.553 281.497C231.434 277.858 236.346 271.047 244.517 266.28Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.046 323.458C154.493 336.515 164.14 346.161 174.594 345.003C185.047 343.845 192.349 332.321 190.903 319.264C189.456 306.206 179.809 296.56 169.355 297.718C158.902 298.876 151.6 310.4 153.046 323.458Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.721 323.162C160.83 316.075 164.712 309.704 170.387 308.948C176.062 308.192 181.382 313.32 182.269 320.419C183.16 327.506 179.278 333.877 173.603 334.633C167.928 335.389 162.608 330.261 161.721 323.162Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.729 315.371C194.171 303.087 199.426 292.255 207.46 291.17C215.486 290.089 223.263 299.174 224.813 311.462C226.371 323.747 221.116 334.579 213.082 335.664C205.056 336.744 197.279 327.66 195.729 315.371Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.384 314.888C201.541 308.2 204.393 302.308 208.765 301.721C213.136 301.134 217.362 306.079 218.201 312.76C219.045 319.448 216.193 325.34 211.821 325.927C207.449 326.514 203.223 321.569 202.384 314.888Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.736 347.129C188.662 352.731 191.449 363.522 199.962 371.232C208.474 378.941 219.487 380.65 224.561 375.049C229.635 369.447 226.847 358.656 218.335 350.946C209.823 343.236 198.809 341.527 193.736 347.129Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.491 366.953C199.837 362.787 198.266 356.904 200.98 353.827C203.697 350.739 209.676 351.619 214.33 355.785C218.985 359.951 220.556 365.834 217.842 368.911C215.124 371.999 209.146 371.119 204.491 366.953Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.315 352.491C226.475 350.287 220.55 343.388 222.067 337.086C223.585 330.784 231.98 327.463 240.824 329.675C249.664 331.879 255.59 338.778 254.072 345.08C252.554 351.382 244.16 354.703 235.315 352.491Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.86 347.375C232.054 346.172 228.826 342.418 229.651 338.991C230.476 335.563 235.045 333.753 239.85 334.956C244.656 336.158 247.884 339.912 247.059 343.34C246.233 346.768 241.665 348.578 236.86 347.375Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.137 381.926C241.21 380.342 233.96 373.745 234.95 367.205C235.939 360.666 244.792 356.64 254.731 358.228C264.658 359.812 271.908 366.41 270.919 372.949C269.921 379.493 261.076 383.514 251.137 381.926Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.278 376.598C246.876 375.739 242.927 372.151 243.47 368.588C244.014 365.026 248.83 362.844 254.233 363.704C259.635 364.563 263.583 368.151 263.04 371.714C262.497 375.276 257.68 377.458 252.278 376.598Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.044 357.666C264.704 358.013 257.675 352.954 257.349 346.368C257.023 339.781 263.52 334.167 271.868 333.816C280.208 333.468 287.237 338.528 287.563 345.114C287.889 351.7 281.391 357.314 273.044 357.666Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.052 352.236C268.512 352.427 264.688 349.671 264.516 346.091C264.343 342.51 267.873 339.45 272.416 339.267C276.955 339.076 280.78 341.832 280.952 345.412C281.124 348.993 277.595 352.053 273.052 352.236Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.927 376.159C287.846 376.825 280.1 372.514 279.614 366.546C279.129 360.578 286.102 355.199 295.175 354.538C304.256 353.872 312.001 358.183 312.487 364.151C312.973 370.119 306 375.498 296.927 376.159Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.825 371.231C291.889 371.589 287.669 369.253 287.407 366.001C287.145 362.75 290.937 359.825 295.872 359.467C300.808 359.108 305.028 361.445 305.29 364.696C305.552 367.948 301.76 370.873 296.825 371.231Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.992 353.315C295.412 352.547 288.039 346.599 288.512 340.018C288.989 333.444 297.13 328.733 306.706 329.493C316.286 330.261 323.659 336.209 323.186 342.79C322.708 349.364 314.568 354.075 304.992 353.315Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.727 340.628C296.416 344.201 300.383 347.465 305.587 347.919C310.792 348.372 315.263 345.843 315.575 342.27C315.886 338.697 311.919 335.433 306.714 334.98C301.51 334.526 297.038 337.055 296.727 340.628Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.323 379.862C315.847 377.931 309.961 371.839 311.197 366.249C312.42 360.656 320.287 357.693 328.77 359.62C337.245 361.552 343.131 367.644 341.896 373.233C340.672 378.826 332.806 381.79 324.323 379.862Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.618 375.331C321.004 374.28 317.804 370.965 318.477 367.92C319.142 364.879 323.422 363.271 328.033 364.313C332.648 365.363 335.847 368.678 335.175 371.724C334.51 374.765 330.233 376.381 325.618 375.331Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M338.07 361.24C329.535 357.867 324.458 350.373 326.722 344.497C328.987 338.62 337.746 336.59 346.281 339.963C354.816 343.336 359.894 350.83 357.629 356.707C355.365 362.583 346.605 364.613 338.07 361.24Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M340.218 356.524C335.576 354.691 332.813 350.613 334.042 347.417C335.279 344.217 340.037 343.115 344.683 344.956C349.325 346.789 352.088 350.867 350.858 354.063C349.621 357.263 344.864 358.365 340.218 356.524Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.718 395.373C341.131 388.399 342.746 381.34 347.32 379.598C351.893 377.856 357.7 382.104 360.287 389.079C362.873 396.053 361.258 403.112 356.685 404.854C352.111 406.596 346.305 402.348 343.718 395.373Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.567 394.173C346.164 390.38 347.033 386.536 349.524 385.593C352.015 384.65 355.172 386.959 356.583 390.748C357.986 394.541 357.116 398.385 354.625 399.328C352.134 400.27 348.978 397.962 347.567 394.173Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.922 383.592C355.877 377.684 355.862 370.613 359.895 367.803C363.929 364.992 370.478 367.5 374.534 373.412C378.579 379.32 378.594 386.391 374.561 389.201C370.527 392.011 363.979 389.504 359.922 383.592Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.369 381.473C361.17 378.258 361.161 374.411 363.353 372.879C365.545 371.346 369.115 372.712 371.314 375.927C373.513 379.141 373.523 382.988 371.331 384.521C369.139 386.053 365.568 384.687 363.369 381.473Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.715 419.087C349.781 412.386 354.234 407.49 358.65 408.161C363.066 408.831 365.781 414.801 364.707 421.506C363.64 428.206 359.187 433.102 354.771 432.431C350.356 431.761 347.64 425.792 348.715 419.087Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.305 419.857C352.887 416.214 355.305 413.555 357.709 413.908C360.109 414.274 361.59 417.522 361.008 421.165C360.427 424.808 358.009 427.467 355.605 427.114C353.204 426.748 351.724 423.5 352.305 419.857Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.216 409.358C368.411 402.54 373.99 398.194 378.685 399.666C383.375 401.131 385.406 407.852 383.211 414.671C381.016 421.489 375.438 425.835 370.743 424.363C366.052 422.898 364.022 416.177 366.216 409.358Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.999 410.784C371.191 407.074 374.23 404.714 376.783 405.504C379.339 406.302 380.44 409.961 379.248 413.672C378.057 417.382 375.017 419.742 372.465 418.952C369.909 418.154 368.808 414.495 369.999 410.784Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.029 435.141C360.509 429.313 365.744 426.005 368.722 427.742C371.704 429.486 371.294 435.631 367.822 441.455C364.341 447.283 359.106 450.592 356.124 448.847C353.142 447.102 353.552 440.957 357.025 435.133L357.029 435.141Z",
    fill: "#F0869D",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.365 436.771C361.254 433.602 364.101 431.797 365.729 432.749C367.345 433.697 367.13 437.037 365.233 440.21C363.343 443.379 360.497 445.183 358.869 444.232C357.253 443.284 357.468 439.943 359.365 436.771Z",
    fill: "#F7C6CF",
    stroke: "#7A1D24",
    strokeWidth: 1.42,
    strokeMiterlimit: 10
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTentacleHeader);
export default __webpack_public_path__ + "static/media/tentacle_header.398d02a732e7304c6d1577ddae3f7759.svg";
export { ForwardRef as ReactComponent };